import type { operations } from '@joyful/openapi/types.gen'
import { createContext } from 'react'

export type EncounterListFacetsQuery = NonNullable<
  operations['getEncounterFacets']['parameters']['query']
>

// Facet filters and view of the encounter list that wraps this subtree; null outside a list.
export const EncounterListFacetsQueryContext =
  createContext<EncounterListFacetsQuery | null>(null)
